import type { JSX } from 'react'
import type { COLOR } from 'vars/index'

import { useMemo, useRef } from 'react'
import { useCurrentCard } from 'blocks/Grid/hooks'
import { RowSkeletonItem } from 'blocks/Skeletons/components/RowSkeleton/RowSkeleton.styled'
import { Skeleton } from 'blocks/Skeletons/Skeleton'
import { CardsInRow } from 'containers/RowContainer'
import { useClientWidth } from 'utils/hooks'
import { COLLECTION_GAPS } from 'vars/index'
import {
  SearchGridSkeletonInnerSC,
  SearchGridSkeletonSC,
  SearchGridSkeletonTitleSC,
} from './SearchGridSkeleton.styled'

export interface ISearchGridSkeleton {
  cardsAspectRatio?: number
  rowGap?: COLLECTION_GAPS
  columnGap?: COLLECTION_GAPS
  totalRows?: number
  tvChannelCard?: boolean
  cardsInRow: CardsInRow
  withTitle?: boolean
  height?: string
  pageBackgroundColor?: COLOR
}

export const SearchGridSkeleton = ({
  cardsAspectRatio = 1.78,
  rowGap = COLLECTION_GAPS.GRID_GAP_SEARCH_VERTICAL,
  columnGap = COLLECTION_GAPS.GRID_GAP_SEARCH_HORIZONTAL,
  totalRows = 6,
  tvChannelCard = false,
  cardsInRow = CardsInRow.Horizontal_5,
  withTitle = true,
  height,
  pageBackgroundColor,
}: ISearchGridSkeleton): JSX.Element => {
  const gridNode = useRef<HTMLDivElement>(null)
  const clientWidth = useClientWidth()
  const cardCount = useMemo(() => +cardsInRow.split('_')[1], [cardsInRow])
  const rowDirection = useMemo(() => cardsInRow?.charAt(0), [cardsInRow])
  const countCard = useCurrentCard({
    cardsInRow: cardCount,
    rowDirection,
    clientWidth,
    tvChannelCard,
  })

  return (
    <Skeleton height={height} pageBackgroundColor={pageBackgroundColor}>
      <SearchGridSkeletonInnerSC
        rowGap={rowGap}
        columnGap={columnGap}
        cardCount={countCard}
        cardsAspectRatio={cardsAspectRatio}
        totalRows={totalRows}
      >
        {Boolean(withTitle) && <SearchGridSkeletonTitleSC />}
        <SearchGridSkeletonSC ref={gridNode}>
          {new Array(totalRows * countCard).fill(' ').map((_, index) => (
            <RowSkeletonItem key={`${Math.random()}_${index}`} />
          ))}
        </SearchGridSkeletonSC>
      </SearchGridSkeletonInnerSC>
    </Skeleton>
  )
}
